(() => {
  'use strict';
  const TS = window.ThreeSheep;
  if (!TS) return;
  const controllers = new WeakMap();
  const states = new WeakMap();
  const parseVariant = root => {
    const node = root.querySelector('[data-selected-variant]');
    return node ? JSON.parse(node.textContent) : null;
  };
  function selectMedia(root, id) {
    if (!id) return;
    const target = [...root.querySelectorAll('[data-media-id]')].find(node => node.dataset.mediaId === String(id));
    if (!target) return;
    root.querySelectorAll('[data-media-id]').forEach(slide => {
      const active = slide === target;
      slide.classList.toggle('is-active', active);
      if (!active) {
        slide.querySelectorAll('video').forEach(video => video.pause());
        slide.querySelectorAll('iframe').forEach(frame => { frame.src = frame.src; });
      }
    });
    root.querySelectorAll('[data-gallery-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryTarget === String(id))));
  }
  function updateSticky(root) {
    const state = parseVariant(root);
    if (!state) return;
    states.set(root,state);
    const button = root.querySelector('[data-sticky-add]'), label = root.querySelector('[data-add-button] span');
    if (button) { button.disabled = !state.available; const text = button.childNodes[0]; if (text?.nodeType === Node.TEXT_NODE) text.textContent = label?.textContent || ''; }
    const price = root.querySelector('[data-sticky-price]');
    if (price) price.textContent = state.money;
    root.querySelectorAll('select[data-variant-id]').forEach(select => { select.disabled = !state.available; });
    updatePlanPrice(root);
  }
  function updatePlanPrice(root) {
    const plan = root.querySelector('[data-selling-plan]'), option = plan?.selectedOptions[0];
    if (!option?.dataset.price) return;
    const regular = root.querySelector('[data-product-panel] .price>span:not(.visually-hidden)');
    if (regular) regular.textContent = option.dataset.price;
    const sticky = root.querySelector('[data-sticky-price]');
    if (sticky) sticky.textContent = option.dataset.price;
    const compare = root.querySelector('[data-product-panel] .price s');
    if (compare) compare.hidden = !!plan.value;
  }
  async function updateOptions(input) {
    const root = input.closest('[data-product-root]');
    if (!root) return;
    controllers.get(root)?.abort();
    const controller = new AbortController(); controllers.set(root,controller);
    const checked = [...root.querySelectorAll('[data-option-input]:checked')].map(option => option.value);
    const url = new URL(input.dataset.productUrl || root.dataset.productUrl, location.origin);
    if (url.origin !== location.origin) return;
    url.searchParams.set('option_values', checked.join(','));
    url.searchParams.set('section_id', root.dataset.sectionId);
    const panel = root.querySelector('[data-product-panel]');
    const quantity = panel.querySelector('[name="quantity"]')?.value;
    const planId = panel.querySelector('[data-selling-plan]')?.value;
    panel.setAttribute('aria-busy','true');
    root.querySelectorAll('[data-add-button],[data-sticky-add]').forEach(button => { button.disabled = true; });
    const inputPosition = input.dataset.optionPosition, inputValue = input.value;
    try {
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error(TS.config.strings.variantError);
      const documentNext = new DOMParser().parseFromString(await response.text(),'text/html');
      const nextRoot = documentNext.querySelector('[data-product-root]');
      const next = nextRoot?.querySelector('[data-product-panel]');
      if (!next) throw new Error(TS.config.strings.variantError);
      if (controller.signal.aborted) return;
      if (nextRoot.dataset.productUrl !== root.dataset.productUrl) {
        url.searchParams.delete('section_id'); location.assign(url.toString()); return;
      }
      panel.replaceWith(next);
      window.Shopify?.PaymentButton?.init?.();
      const quantityInput = next.querySelector('[name="quantity"]');
      if (quantityInput && quantity) {
        const min = Number(quantityInput.min || 1), max = quantityInput.max ? Number(quantityInput.max) : Infinity, step = Number(quantityInput.step || 1);
        quantityInput.value = Math.min(max, Math.max(min, min + Math.floor((Number(quantity) - min) / step) * step));
      }
      const plan = next.querySelector('[data-selling-plan]');
      if (plan && [...plan.options].some(option => option.value === planId)) plan.value = planId;
      const focus = [...next.querySelectorAll('[data-option-input]')].find(option => option.dataset.optionPosition === inputPosition && option.value === inputValue);
      focus?.focus({preventScroll:true});
      updateSticky(root);
      const selected = parseVariant(root);
      selectMedia(root, selected?.mediaId);
      const address = new URL(location.href);
      address.searchParams.delete('variant'); address.searchParams.delete('option_values');
      if (selected?.id) address.searchParams.set('variant',selected.id);
      else address.searchParams.set('option_values',checked.join(','));
      history.replaceState({},'',address);
      TS.emit('variant_changed',{product_id:selected?.productId,variant_id:selected?.id,available:selected?.available});
    } catch (error) {
      if (error.name === 'AbortError') return;
      const message = panel.querySelector('[data-product-error]');
      if (message) { message.textContent = TS.config.strings.variantError; message.hidden = false; }
      TS.announce(TS.config.strings.variantError);
    } finally {
      if (controllers.get(root) === controller) root.querySelector('[data-product-panel]')?.removeAttribute('aria-busy');
    }
  }
  function init(scope = document) {
    const roots = [...scope.querySelectorAll('[data-product-root]')];
    if (scope.matches?.('[data-product-root]')) roots.push(scope);
    roots.forEach(root => {
      if (root.dataset.productReady) return;
      root.dataset.productReady = 'true'; updateSticky(root);
      root.addEventListener('change',event => {
        if (event.target.matches('[data-option-input]')) updateOptions(event.target);
        if (event.target.matches('[data-selling-plan]')) updatePlanPrice(root);
      });
      root.addEventListener('click',event => {
        const button = event.target.closest('[data-gallery-target]');
        if (button) selectMedia(root,button.dataset.galleryTarget);
      });
      const sticky = root.querySelector('[data-sticky-cart]');
      if (sticky) {
        const check = () => {
          const form = root.querySelector('[data-product-form]');
          if (!form) return;
          sticky.hidden = form.getBoundingClientRect().bottom > 0;
        };
        let scheduled = false;
        const scroll = () => { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; check(); }); };
        addEventListener('scroll',scroll,{passive:true}); addEventListener('resize',scroll);
        root.cleanupProduct = () => { removeEventListener('scroll',scroll); removeEventListener('resize',scroll); };
        check();
      }
      const variant = parseVariant(root);
      if (variant) TS.emit('view_item',{currency:TS.config.currency,value:variant.price/100,items:[{item_id:String(variant.id),item_name:variant.title,item_variant:variant.variantTitle,price:variant.price/100,quantity:1}]});
    });
  }
  let viewerTimeout;
  document.addEventListener('three-sheep:viewers',event => {
    if (!TS.config.viewers) return;
    const { productId, count, timestamp } = event.detail || {};
    if (!Number.isInteger(count) || count <= 0 || !Number.isFinite(timestamp) || Math.abs(Date.now()-timestamp) > 60000) return;
    document.querySelectorAll('[data-live-viewers]').forEach(node => {
      if (String(productId) !== node.dataset.productId) return;
      node.textContent = TS.config.strings.viewers.replace('__COUNT__',String(count)); node.hidden = false;
    });
    clearTimeout(viewerTimeout);
    viewerTimeout = setTimeout(() => document.querySelectorAll('[data-live-viewers]').forEach(node => { node.hidden = true; }),60000);
  });
  document.addEventListener('shopify:section:unload',event => event.target.querySelector('[data-product-root]')?.cleanupProduct?.());
  document.addEventListener('three-sheep:section_load',event => init(event.detail.root));
  init();
})();
